import { render, staticRenderFns } from "./MinistroAvance.vue?vue&type=template&id=7def80a6&"
import script from "./MinistroAvance.vue?vue&type=script&lang=js&"
export * from "./MinistroAvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports